import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { useInView } from '@cian/valuation-utils-component';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { CardSectionNew } from 'shared/components/CardSectionNew';
import { RosreestrInfoNew } from 'shared/components/RosreestrInfoNew';

import { useFormattedInfo } from './hooks';
import { trackCadastralMapPreviewClick, trackCadastralMapView, trackRosreestrInfoShow } from './tracking';
import { getRosreestrInfo } from '../../selectors/offerData/getRosreestrInfo';

export const RosreestrInfoContainer = () => {
  const rosreestrInfo = useSelector(getRosreestrInfo);

  const { formattedInfo, onExpand, showExpandButton } = useFormattedInfo(rosreestrInfo);

  const { ref, inView } = useInView({
    threshold: 0,
    triggerOnce: true,
  });

  React.useEffect(() => {
    if (inView) {
      trackCadastralMapView();
    }
  }, [inView]);

  if (!formattedInfo) {
    return null;
  }

  return (
    <ActionAfterViewObserver callback={trackRosreestrInfoShow} triggerOnce>
      <CardSectionNew title={rosreestrInfo?.header} subtitle={rosreestrInfo?.bottom}>
        <RosreestrInfoNew
          {...formattedInfo}
          onExpand={onExpand}
          showExpandButton={showExpandButton}
          cadastralMapRef={ref}
          onCadastralMapClick={trackCadastralMapPreviewClick}
        />
      </CardSectionNew>
    </ActionAfterViewObserver>
  );
};
